module.exports = __webpack_public_path__ + "img/purpose5.b9bb7603.png";